import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  padding: 1rem;

  font-family: "Mulish";

  background-color: #f5f5f5;

  #header {
    font-size: 1.3rem;
    font-weight: 500;
  }

  span {
    font-size: 1.2rem;
    font-weight: 500;

    color: #3751ff;
  }

  .hidden {
    display: none;
  }

  .show {
    display: flex;
  }
`;

export const Content = styled.div`
  display: flex;

  width: 100%;
  height: 100%;

  .left-side {
    display: flex;

    justify-content: center;

    width: 80%;
    height: 100%;

    padding: 2rem 1rem;
  }

  #process-manager {
    width: 95%;
    height: 100%;

    padding: 0.5rem 0.5rem 0.5rem 0;

    p {
      margin: 1rem 0 2rem 1rem;
    }
  }

  .process-wrapper {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;

    overflow: auto;

    padding: 0.5rem 0.5rem 0.5rem 0;
  }

  #mail {
    text-transform: none;
  }

  #name {
    font-weight: 600;

    color: black;

    text-transform: capitalize;
  }

  .tr-wrapper {
    display: flex;

    width: 100%;
    height: 6rem;

    min-height: 6rem;

    font-size: 1rem;

    border-bottom: #dfe0eb 1px solid;

    white-space: nowrap;

    align-items: center;
    justify-content: center;

    :hover {
      background-color: #dfe0eb;
      cursor: pointer;
    }
  }

  #tr-title {
    cursor: default;

    font-size: 1.2rem;

    background-color: white;
  }

  th,
  td {
    display: flex;

    width: 100%;
    height: 2rem;

    align-items: center;
    justify-content: center;
  }

  td {
    font-family: "Mulish";

    font-size: 1.1rem;
    font-weight: 300;

    width: 20%;

    line-height: 14px;

    color: #8a8a8a;

    text-transform: uppercase;
  }

  .status {
    display: flex;

    color: white;
    border-radius: 1rem;

    width: 5rem;
    height: 2rem;

    justify-content: center;
    align-items: center;

    font-weight: 700;
  }

  .online {
    background-color: #29cc97;
  }

  .offline {
    background-color: #cc2929;
  }

  .right-side {
    display: flex;
    flex-direction: column;

    width: 20%;
    height: 100%;

    gap: 2rem;

    padding: 2rem 1rem;
  }

  .content {
    display: flex;
    flex-direction: column;

    width: 60%;

    background-color: white;

    border-radius: 0.25rem;

    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }

  #create-user-container {
    display: flex;

    height: 10rem;

    align-items: center;
    justify-content: center;
  }

  .create-user {
    display: flex;

    width: 85%;
    height: 5rem;

    align-items: center;
    justify-content: space-evenly;

    background-color: rgba(55, 81, 255, 0.25);

    border: none;
    border-radius: 0.25rem;

    color: #3715ff;

    padding: 0.5rem;

    font-size: 1.25rem;
    font-weight: 700;

    cursor: pointer;

    transition: 0.4s;

    #icon {
      width: 2rem;
      height: 2rem;
    }
  }

  .create-user:hover {
    background-color: #3715ff;

    color: white;
  }

  .filter-button {
    width: 100%;
    height: 2.5rem;

    border: none;
    border-bottom: 1px solid #dfe0eb;
    background-color: white;

    cursor: pointer;
    color: #8a8a8a;

    font-size: 1.2rem;
    font-weight: 600;

    :hover {
      background-color: #f5f5f5;
    }
    :last-child {
      border: none;

      border-radius: 0 0 0.25rem 0.25rem;
    }
  }

  .filter-header {
    display: flex;

    padding: 0.5rem;

    border-bottom: 1px solid #dfe0eb;

    align-items: center;
    justify-content: space-evenly;

    position: relative;

    .filter-text {
      font-size: 1.2rem;
      font-weight: 600;
    }

    #icon {
      position: absolute;

      left: 0.5rem;
    }
  }

  table > a {
    text-decoration: none;

    :active {
      text-decoration: none;
    }
  }
`;
